// extracted by mini-css-extract-plugin
module.exports = {"custom_select":"Select_custom_select__qrKpE","custom_select_arrow":"Select_custom_select_arrow__1bhW-","custom_select_dropdown":"Select_custom_select_dropdown__2GPTI"};